import {Injectable} from '@angular/core';
import {Event, NavigationEnd, Router} from '@angular/router';
import {BehaviorSubject, Subject} from 'rxjs';
import { NavList } from '../models/navlist.model';
import { CommonService } from './common.service';

// @Injectable()
@Injectable({providedIn:'root'})
export class NavService {
  public appDrawer: any;
  public currentUrl = new BehaviorSubject<string>(undefined);
  share: any;
  navItems:NavList[];
  constructor(private router: Router,private commonService:CommonService) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl.next(event.urlAfterRedirects);
      }
    });
  }
  invokeEvent: Subject<any> = new Subject();
  triggerFunction(type,item) {
    this.invokeEvent.next({type,item})
  }

  public closeNav() {
    this.appDrawer.close();
  }

  public openNav() {
    this.appDrawer.open();
  }

  findFolderID(urlsegments){
      let url = urlsegments[0]+'/'+urlsegments[1]+'/'+urlsegments[2];
      url = url.replace(new RegExp('%2B', 'g'), '+');
      for(let i=0;i<this.navItems.length;i++){
      if(this.navItems[i].children){
      for(let j=0;j<this.navItems[i].children.length;j++){
          if(this.navItems[i].children[j].route.includes(url)){

            return this.navItems[i].children[j].id;
          }
      }
    }
  }
  }

  checkValidity(folderName: string) {
    var splChars = "*|_,/\":<>[]{}`\';()@&$#%!^-=+?.\\~";
    for (var i = 0; i < folderName.length; i++) {
      if (splChars.indexOf(folderName.charAt(i)) != -1) {
        // alert ("Name cannot contain special characters!!");
        this.commonService.setNotification("Folder/File name cannot contain special characters!!", "Error")
        return false;
      }
    }
    var restrictedWords = ['article', 'edit'];
    for (var i = 0; i < restrictedWords.length; i++) {
      if (folderName.toLocaleLowerCase().includes(restrictedWords[i])) {
        // alert ("Name cannot contain restricted words! Eg. - " + restrictedWords[i]);
        this.commonService.setNotification("Folder/File name cannot contain restricted words! Eg. - " + restrictedWords[i], "Error")
        return false;
      }
    }
    return true;
  }
}
